import { useEffect, useMemo } from "react";
import GetAllStore from "../api/GetAllStore";
import { getAllReview } from "../api/reviewApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SETALLCATEGORY, SETALLSTORE, SETDOMAINSETTING, SETFEATUREDITEM, SETSELECTEDSTORE, setStoreDeliveryPickupAllow, SETSTORETYPE } from "../redux/features/store";
import { SETSELECTEDCATEGORY } from "../redux/features/categoryList";
import { getFeaturedItemList } from "../utils/helper";
import { sortByNameCategoryData } from "../utils/SortingCategory";

const useAllApiCall = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    filterData: { search, filterCategory },
    cartData: { itemCount, items, totalPrice, isCartOpen },
    store: { allCategory, selectedStore, allStore, selectedType },
  }: any = useSelector((state: any) => state);

  const getStoreInfo = (info?: any) => {
    const search = info ? info : { search_item: "", longitude: sessionStorage.getItem("longitude") || '', latitude: sessionStorage.getItem("latitude") || '' };
    let json = { lat: search.latitude, long: search.longitude }
    getData(json)
  }
  // console.log("allStore_fetch", allStore)

  const isStoreDataFetched = useMemo(() => {
    return allStore.length ? true : false
  }, [allStore])

  const getData = async ({ lat, long }: { lat: any; long: any }) => {

    // if (allStore?.length) {
    //   return;
    // }
    const data = await GetAllStore({ latitude: lat, longitude: long });


    if (data.success) {
      if (data.all_Store?.length) {
        let selected_store_id = selectedStore?.store_id;
        if (data.all_Store?.length == 1 || selected_store_id) {
          storeChangeSelection(data.all_Store, selected_store_id || '');
        }

        dispatch(SETALLSTORE(data.all_Store));
        // navigate(`?slug=${selectedStore?.Category_data?.[0]?.slug}`);
      }
      if (data?.domain_details) {
        dispatch(SETDOMAINSETTING(data?.domain_details));
      }
    } else {
      navigate("/something-wrong");
    }

  };


  const storeChangeSelection = (allStore: any, selectedStoreId: any) => {
    const selectedStore = selectedStoreId ? allStore.find((store: any) => store.store_data?.store_id == selectedStoreId) : allStore[0];

    if (allStore?.length == 1) {
      selectedStoreId = allStore[0]
    }
    sessionStorage.setItem("country_currency", selectedStore.store_data?.country_currency);

    const storeId = selectedStore.store_data?.store_id || "";
    getAllReview(dispatch, storeId);
    sessionStorage.setItem("store-id", storeId);
    dispatch(SETSELECTEDSTORE(selectedStore.store_data));
    let sort_category = sortByNameCategoryData(selectedStore?.Category_data)
    dispatch(SETALLCATEGORY(sort_category));
    dispatch(SETSELECTEDCATEGORY(sort_category?.[0]?.slug));
    let storeDeliveryPickType = returnTypeOfStore(selectedStore.store_data);
    let storeType = (storeDeliveryPickType?.delivery == true) ? '3' : (storeDeliveryPickType?.pickup == true) ? '1' : '2';
    let selected_store_type = sessionStorage.getItem("store_type") as any;
    const isValidStoreType = (selected_store_type == "3" && storeDeliveryPickType?.delivery) || (selected_store_type == "1" && storeDeliveryPickType?.pickup);
    if (!selected_store_type || !isValidStoreType) {
      sessionStorage.setItem("store_type", storeType);
     
    //  @@ this is for set srtore set values
      let storeTypeValue = storeType;
      const storeSelectedType = selectedType;
      if (storeSelectedType !=null && storeSelectedType !=undefined && storeSelectedType !='') {
        storeTypeValue = (storeSelectedType == 3 && storeDeliveryPickType?.delivery == true) ? '3' : (storeSelectedType == 1 && storeDeliveryPickType?.pickup == true) ? "1" : "2"
      }
      dispatch(SETSTORETYPE(storeTypeValue));
    } else {
      sessionStorage.removeItem("store_type");
    }
    dispatch(setStoreDeliveryPickupAllow(storeDeliveryPickType))
    const featuredItem = getFeaturedItemList(selectedStore?.Category_data);
    dispatch(SETFEATUREDITEM(featuredItem));
  }

  return { getStoreInfo, isStoreDataFetched, storeChangeSelection }
}
export default useAllApiCall;

const returnTypeOfStore = (storeData: any) => {
  let mstStoreType = storeData?.map_store_type;

  // 1 for pickup , 2 for dining and 3 for delivery
  const isDelivery = mstStoreType?.some((i: any) => i?.status == 3);
  const isPickup = mstStoreType?.some((i: any) => i?.status == 1);
  return {
    dinning: mstStoreType?.some((i: any) => i?.status == 2),
    pickup: isPickup,
    delivery: isDelivery,
    isPickupNDelivery: isPickup == true || isDelivery == true ? true : false,
  };
};

